module.exports = __webpack_public_path__ + "static/merkel-175b748d8d0200db5b314325739ccff6.jpg";